<mat-icon
	[ngClass]="{
		'icon-filled': filled,
		'animate-spin': spin,
	}"
	fontSet="material-symbols-rounded"
>
	{{ name }}
</mat-icon>
